module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0004.jpg?v=9b6423b4";